var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.$t(_vm.errors),
    placement: 'top-center',
    classes: ['info'],
    targetClasses: ['it-has-a-tooltip'],
    offset: 0,
    delay: {
      show: 500,
      hide: 300,
    },
    show: _vm.status === 'KO',
    trigger: 'manual'
  }),expression:"{\n    content: $t(errors),\n    placement: 'top-center',\n    classes: ['info'],\n    targetClasses: ['it-has-a-tooltip'],\n    offset: 0,\n    delay: {\n      show: 500,\n      hide: 300,\n    },\n    show: status === 'KO',\n    trigger: 'manual'\n  }"}],attrs:{"id":"file-drag-drop"}},[_c('form',{ref:"fileform"},[_c('label',{attrs:{"for":"files_id"}},[_c('input',{attrs:{"name":"upload","id":"files_id","type":"file","accept":_vm.acceptedFileTypes},on:{"change":_vm.fileChosen}}),_c('strong',[_vm._v(_vm._s(_vm.$t('uploads.click')))]),_c('span',[_vm._v(_vm._s(_vm.$t('uploads.drag')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }